<template>
  <div class="card">
    <div class="card-body">
      <b-table head-row-variant="info" table-variant="white" :items="targetList" :fields="targetListHeaders" hover responsive sort-icon-left show-empty>
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı" }}
          </h6>
        </template>
        <template #cell(startDate)="data">
          <div class="text-start">
            {{ formattedDate(data.item.startDate)}}
          </div>
        </template>
        <template #cell(finishDate)="data">
          <div class="text-start">
            {{ formattedDate(data.item.finishDate)}}
          </div>
        </template>
          <template #table-busy>
            <div class="text-center">
              <b-spinner variant="primary" size="lg" label="Lütfen Bekleyin...">
              </b-spinner>
            </div>
        </template>
        <template #cell(process)="data">
          <div class="text-center">
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" icon color="amber darken-2" @click="openAddSalespersonDialog(data.item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Düzenle</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" icon color="amber darken-2" @click="_salespersonTargetDelete(data.item.id)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Sil</span>
            </v-tooltip>
          </div>
        </template>
      </b-table>
      <NewTargetDialog
          :targetProp="editSalesPersonTargetProp"
          :processType="'edit'"
          :showDialog="editSalesPersonTargetDialog"
          @dialogChange="(data) => (editSalesPersonTargetDialog = data)">
      </NewTargetDialog>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import NewTargetDialog from "@/components/management/target/salesperson/dialogs/NewTargetDialog.vue";
import {formattedDate, formatTest} from "../../../../../momentHelper";

export default {
  name: "ResultsTableView",
  components: {NewTargetDialog},
  data() {
    return {
      editSalesPersonTargetProp: null,
      editSalesPersonTargetDialog: false,
    };
  },
  computed: {
    ...mapState("dashboard",["errorMessageAll"]),
    ...mapState("target",["targetListHeaders","targetList"])
  },
  methods: {
    formattedDate,
    formatTest,
    ...mapActions("target",["salespersonTargetDelete"]),
    openAddSalespersonDialog(data) {
      this.editSalesPersonTargetProp = data;
      this.editSalesPersonTargetDialog = true;
    },

    // await this.stockImageDelete({
    //   params: {},
    //   body: {},
    //   urlSegments: [item.id],
    // });


   async  _salespersonTargetDelete(id){
      await this.salespersonTargetDelete({
        params: {},
        body:{},
        urlSegments: [id],
      })
    }
  },
  watch: {
    "editSalesPersonTargetDialog": function (newVal) {
      if (!newVal)
        this.editSalesPersonTargetProp = null;
    }
  }
};
</script>

<style scoped>

</style>